/* eslint-disable prettier/prettier */
/**
 * Created by rastwe on 1/13/2017.
 * @module $Name$
 * @extends React.Component
 */
/* eslint react/no-multi-comp: 0*/

import * as FeatureConfigurationAction from '../actions/featureconfigurationaction';
import * as UserSettingsAction from '../actions/usersettingsaction';

import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import {setDateFormat, setLanguage, urls} from '../util/uiconstants';

import AccessDeniedMessage from './Common/AccessDeniedMessage/AccessDeniedMessage';
import AdminNav from './Nav/AdminNav';
import Async from '@ey/async';
import BreadCrumbNavigation from './Nav/BreadCrumbNavigation';
import CreateReviewCopy from './Engagements/crpWrapper';
import Dashboard from './Engagements';
import EditEngagementWizardLoader from './WorkflowWizards/EngagementWorkflowsNew/wizardloadereditengagement';
import EngagementWizardLoader from './WorkflowWizards/EngagementWorkflowsNew/EngagementWizardLoader';
import Errors from '../components/Common/Errors/Errors';
import GroupAuditLinkWizardLoader from './WorkflowWizards/GroupAuditLinkWorkflow/GroupAuditLinkWizardLoader.js';
import ImportDataPackageWizardLoader from './WorkflowWizards/ImportDataPackageWorkflow/wizardloaderimportdatapackage';
import ImportWizard from './WorkflowWizards/ImportWorkflow/wizardloaderimport';
import TimeTracking from './TimeTracking/TimeTracking';
import Loader from '@ey/loader';
import LoaderContainer from './LoaderContainer';
import Main from './Main/Main';
import PageHeader from './Nav/pageheader';
import React from 'react';
import ReportingHub from './ReportingHub/ReportingHub';
import RestoreEngagementWizard from './WorkflowWizards/RestoreWorkflow/RestoreEngagementWizard.js';
import RollForwardEngagementWizard from './WorkflowWizards/RollForwardWorkflow/RollForwardEngagementWizard';
import SampleTest from './devonly/sampletest';
import TopBarNav from './Common/TopNavBar/TopBarNav';

import UserSettings from './UserSettings/UserSettings';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import env from '../util/env';
import {getAdminRoutes} from './Admin/common/util';
import {hot} from 'react-hot-loader';
import {labels} from '../util/uiconstants';
import styled from 'styled-components';
import IndependenceOnlyRejectInvite from './Engagements/IndependenceOnlyRejectInvite';
import {
	CookieConsentModal,
	CookieSettings,
	adobeAnalytics
} from '@ey/voltron-analytics';
import envConfig from '@ey/voltron-config';
import {
	clickActionArgs,
	pageViewArgs
} from './Common/Adobe Analytics/actionHelpers.js';
import {pageNames, siteSections} from './Common/Adobe Analytics/constants.js';

const COOKIE_SETTINGS_PATH = '/cookiesettings';
const adobeAnalyticsEnabled = envConfig.adobeAnalytics?.enabled;

const Wrapper = styled.section`
	.header {
		display: flex;
		.wrapper {
			width: 100%;
			background: var(--neutrals-bg-gradient1);
			.mainwrapper {
				display: flex;
			}
			.title-wrapper {
				width: calc(100vw - var(--px-80));
				margin: 0 auto;
				max-width: 2048px;
			}
		}
	}
`;

const RootContainer = styled.section`
	&.portfolio-view {
		.view-wrapper {
			overflow: hidden;
			.portfolio-loader {
				position: relative;
				.motif-loader-fullscreen {
					position: absolute;
					height: calc(100vh - var(--px-135));
				}
			}
		}
	}
	//.root-container {
	//	background: url('../img/hero_image_Cockpit.png') no-repeat;
	//	background-size: 100% var(--px-406);
	//	.rootcontainer-wrapper {
	//		background: linear-gradient(rgba(255, 255, 255, 0) 0.19%,#fff var(--px-406),#fff var(--px-406),#fff 100%);
	//	}
	//}
	//.root-container[theme='dark'] {
	//	background: url('../img/hero_portfolio.png') no-repeat;
	//	background-size: 100% var(--px-406);
	//	.rootcontainer-wrapper {
	//		background: linear-gradient(rgba(35, 35, 47, 0) 0.19%,#232334 var(--px-406),#23232f var(--px-406),#23232f 100%);
	//	}
	//}
`;
//import '../util/register-service-worker';

/* the import() call must be located in this outer function. Placing it
 * inside load() will cause Webpack to raise a warning about a required
 * file path being an expression.
 * The value of the component={} attribute must be a function or a
 * React component. React-Router sends the props in as the first parameter,
 * so grab those and forward them to the Async.load() as the first
 * argument. The second argument must be an import() statement. */

// const userSettings = (props) =>
// 	Async.load(props, import('./UserSettings/UserSettings'));

const archives = (props) => Async.load(props, import('./Archives'));

const redirectRoutes = [
	{
		path: '/reviewengagements',
		component: Dashboard
		// Adobe Analytics: page tracking is moved in dashboard component to fix flicker issue related to tab control
	},
	{
		path: '/usersettings',
		component: adobeAnalytics.TrackPageView(
			UserSettings,
			pageViewArgs(pageNames.userSettings, siteSections.userSettings)
		)
	}
];

const routes = [
	{
		path: '/test',
		component: SampleTest
	},
	{
		path: '/createengagement',
		component: adobeAnalytics.TrackPageView(
			EngagementWizardLoader,
			pageViewArgs(
				pageNames.createEngagement,
				siteSections.engagementsHome,
				true
			)
		)
	},
	{
		path: '/import',
		component: adobeAnalytics.TrackPageView(
			ImportWizard,
			pageViewArgs(pageNames.importTemplate, siteSections.engagementsHome, true)
		)
	},
	{
		path: '/editengagement',
		component: adobeAnalytics.TrackPageView(
			EditEngagementWizardLoader,
			pageViewArgs(pageNames.editEngagement, siteSections.engagementsHome, true)
		)
	},
	{
		path: '/restore',
		component: adobeAnalytics.TrackPageView(
			RestoreEngagementWizard,
			pageViewArgs(pageNames.restore, siteSections.engagementsHome, true)
		)
	},
	{
		path: '/rollforward',
		component: adobeAnalytics.TrackPageView(
			RollForwardEngagementWizard,
			pageViewArgs(pageNames.rollForward, siteSections.engagementsHome, true)
		)
	},
	{
		path: '/editworkspace',
		component: adobeAnalytics.TrackPageView(
			EditEngagementWizardLoader,
			pageViewArgs(pageNames.editWorkspace, siteSections.workspace, true)
		)
	},
	{
		path: '/datapackagerequest',
		component: adobeAnalytics.TrackPageView(
			ImportDataPackageWizardLoader,
			pageViewArgs(pageNames.dataPackageRequest, siteSections.dataPackage)
		)
	},
	{
		path: '/groupauditlinkrequest',
		component: adobeAnalytics.TrackPageView(
			GroupAuditLinkWizardLoader,
			pageViewArgs(pageNames.groupAudit, siteSections.groupAudit)
		)
	},
	{
		path: '/crp',
		component: adobeAnalytics.TrackPageView(
			CreateReviewCopy,
			pageViewArgs(pageNames.crp, siteSections.crp, true)
		)
	},
	{
		path: '/engagements',
		component: Dashboard
		// Adobe Analytics: page tracking is moved in dashboard component to fix flicker issue related to tab control
	},
	{
		path: '/rejectIndependenceOnlyEngagementInvite/:engagementId?',
		component: adobeAnalytics.TrackPageView(
			IndependenceOnlyRejectInvite,
			pageViewArgs(pageNames.rejectIndependence, siteSections.independence)
		)
	},
	{
		path: '/favorites',
		component: Dashboard
		// Adobe Analytics: page tracking is moved in dashboard component to fix flicker issue related to tab control
	},
	{
		path: '/reviewengagements',
		component: Dashboard
		// Adobe Analytics: page tracking is moved in dashboard component to fix flicker issue related to tab control
	},
	{
		path: '/archives',
		component: adobeAnalytics.TrackPageView(
			archives,
			pageViewArgs(pageNames.archives, siteSections.archives)
		)
	},
	{
		path: '/usersettings',
		component: adobeAnalytics.TrackPageView(
			UserSettings,
			pageViewArgs(pageNames.userSettings, siteSections.userSettings)
		)
	},
	{
		path: '/reportinghub',
		component: adobeAnalytics.TrackPageView(
			ReportingHub,
			pageViewArgs(pageNames.reportingHub, siteSections.reportingHub)
		)
	},
	{
		path: '/timesheet',
		component: adobeAnalytics.TrackPageView(
			TimeTracking,
			pageViewArgs(pageNames.timesheet, siteSections.timesheet)
		)
	},
	{
		path: '/cookiesettings',
		component: adobeAnalytics.TrackPageView(
			() => <CookieSettings locale={labels.cookieSettings} />,
			pageViewArgs(pageNames.cookieSettings, siteSections.consent)
		)
	},
	{
		component: Dashboard
	}
];

const adminRoutes = getAdminRoutes();
class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isFetchingUserDetails: true,
			adobeAnalyticsEmbedded: false
		};

		this.userSettingsUrl = env.getURL('serviceUrl') + '/' + urls.USERS_URL;
		this.featureConfigurationUrl =
			env.getURL('serviceUrl') + '/' + urls.FEATURECONFIGURATION_URL;
		this.userPermissionUrl = env.getURL('serviceUrlV2') + 'admin/Users/Me';
	}

	async componentDidMount() {
		try {
			let path = this.props.location?.pathname;
			if (this.verifyAdminToolUrl(path)) {
				console.log('@@this is admin tool url');
				await this.props.actions.getUserPermissions(this.userPermissionUrl);
				return;
			}
			console.log('@@this is NOT a admin tool url');
			await this.props.actions
				.getUserSettings(this.userSettingsUrl)
				.then(
					await this.props.actions.getFeatureConfiguration(
						this.featureConfigurationUrl
					)
				);
		} finally {
			this.setState({isFetchingUserDetails: false});
		}
	}

	async componentDidUpdate(prevProps) {
		if (prevProps.userSettings !== this.props.userSettings) {
			let data = this.props.userSettings.data;
			if (
				data &&
				data.userlanguageid > 0 &&
				data.userdatetimeformat > -1 &&
				data.usernumberformat > -1
			) {
				setLanguage(data.userlanguageid);
				setDateFormat(data.userdatetimeformat);
			}

			if (
				adobeAnalyticsEnabled &&
				data &&
				data.useremail &&
				!this.state.adobeAnalyticsEmbedded
			) {
				this.props.actions.initAdobeAnalytics(
					data.useremail,
					!data.isguestuser,
					envConfig.adobeAnalytics.defaultDataLayer
				);
				this.setState({adobeAnalyticsEmbedded: true});
			}
		}
	}

	shouldRedirect() {
		if (
			this.props.userSettings?.isError &&
			this.props.userSettings?.request?.response
		) {
			let errorMessage = this.props.userSettings?.response?.data?.ErrorMessage;
			if (errorMessage === '938') {
				return false;
			}
		}

		if (!this.props.userSettings?.data?.isguestuser) {
			if (
				!(
					this.props.userSettings.data &&
					this.props.userSettings.data.id &&
					this.props.userSettings.data.id !==
						'00000000-0000-0000-0000-000000000000' &&
					this.props.userSettings.data.userlanguageid > 0 &&
					this.props.userSettings.data.userdatetimeformat > -1 &&
					this.props.userSettings.data.usernumberformat > -1
				)
			) {
				return true; //EY USER FIRST TIME
			} else {
				return false; //EY USER NOT FIRST TIME
			}
		} else {
			if (
				this.props.userSettings?.data?.isguestuser &&
				(this.props.userSettings.data.userlanguageid === 0 ||
					this.props.userSettings.data.userdatetimeformat === -1 ||
					this.props.userSettings.data.usernumberformat === -1)
			) {
				return true; //GUEST USER FIRST TIME
			} else {
				return false; //GUEST USER NOT FIRST TIME OR NO RECORD
			}
		}
	}

	isGuestUser() {
		if (
			this.props.userSettings?.isError &&
			this.props.userSettings?.request?.response
		) {
			let errorMessage = this.props.userSettings?.response?.data?.ErrorMessage;
			if (errorMessage === '938') {
				return true;
			}
		}

		if (
			this.props.userSettings?.data?.isguestuser !== undefined &&
			this.props.userSettings?.data?.isguestuser !== null
		) {
			return this.props.userSettings?.data?.isguestuser;
		}
		if (
			this.props.userSettings?.request?.response &&
			JSON.parse(this.props.userSettings?.request?.response).ErrorMessage ===
				'938'
		) {
			return true;
		}
		return false;
	}

	shouldRedirectGuestUser() {
		if (location.pathname === '/cookiesettings') {
			return false;
		} else if (
			this.props.userSettings?.isError &&
			JSON.parse(
				this.props.userSettings?.request?.response
			).ErrorMessage.includes('938')
		) {
			return false;
		} else {
			return this.isGuestUser();
		}
	}

	getCookieModal() {
		const onCoookieConsentResult = (type) => {
			this.props.actions.setConsentResult(type);
		};

		return (
			<React.Fragment>
				{this.props.displayCookieConsent &&
					`${location.pathname}${location.search}` !== COOKIE_SETTINGS_PATH && (
						<CookieConsentModal
							settingsURL={COOKIE_SETTINGS_PATH}
							onResult={onCoookieConsentResult}
							appName={labels.versionlabel}
							labels={{
								title: labels.aaCookieConsentTitle,
								prompt: labels.aaCookieContentPrompt,
								explanationHTML: labels.aaCookieConsentExplanation,
								explanationHTMLWithDoNotTrack:
									labels.aaCookieConsentExplanationWithDoNotTrack,
								declineOptionalAction:
									labels.aaCookieConsentDeclineOptionalAction,
								acceptAllAction: labels.aaCookieConsentAcceptAllAction,
								customizeAction: labels.aaCookieConsentCustomizeAction,
								customizeURL: labels.aaCookieConsentCustomizeURL
							}}
						/>
					)}
			</React.Fragment>
		);
	}

	getUniversalAppContainer() {
		const isEngV2 = false;
		return (
			<React.Fragment>
				<section className="root">
					<RootContainer className={isEngV2 ? 'portfolio-view' : ''}>
						<section
							className="root-container"
							theme={
								document
									.getElementsByTagName('body')[0]
									.getAttribute('motif-theme') === 'light'
									? null
									: 'dark'
							}
						>
							{/* <TopNav /> */}
							<TopBarNav />
							<section className="rootcontainer-wrapper">
								<Errors />
								{this.props.isLoading ? <Loader view="fullscreen" /> : null}
								{this.state.isFetchingUserDetails ? (
									<LoaderContainer path={this.props.location} />
								) : (
									<Main>
										<Switch>
											{redirectRoutes.map((eachRoute) => {
												const {path, component} = eachRoute;
												return (
													<Route exact path={path} component={component} />
												);
											})}

											{this.shouldRedirect() ? (
												<Route>
													<Redirect to="/usersettings" />
												</Route>
											) : null}

											{this.shouldRedirectGuestUser() ? (
												<Route>
													<Redirect to="/reviewengagements" />
												</Route>
											) : null}

											{routes.map((eachRoute) => {
												const {path, component} = eachRoute;
												return (
													<Route exact path={path} component={component} />
												);
											})}
										</Switch>
									</Main>
								)}
							</section>
							{this.getCookieModal()}
						</section>
					</RootContainer>
				</section>
			</React.Fragment>
		);
	}

	verifyAdminToolUrl(path) {
		path = path !== null ? path.split('/') : null;
		if (path !== null && path.length > 1 && path[1].toLowerCase() === 'admin') {
			return true;
		}
		return false;
	}

	isValidAdminUser() {
		let permissions = this.props?.userPermissions?.permissions;
		return permissions?.hasAdminDefaultRole;
	}

	getAdminAppContainer() {
		return (
			<React.Fragment>
				<section className="root">
					<Errors />
					<AdminNav />
					{this.props.isLoading ? (
						<Loader view="fullscreen" styleName="loadingstyle" />
					) : null}
					{this.state.isFetchingUserDetails ? (
						<LoaderContainer path={this.props.location} />
					) : (
						<Main>
							<section className="MainContainerWrapper customScrollbar">
								{true ? (
									this.isValidAdminUser() ? (
										<Switch>
											{adminRoutes.map((eachRoute) => {
												const {
													path,
													component,
													breadCrumb,
													moduleName,
													iconName
												} = eachRoute;
												return (
													<Route path={path}>
														<Wrapper>
															<section className="header">
																<wrapper className="wrapper">
																	<section className="mainwrapper mainResponsiveWrapper">
																		<BreadCrumbNavigation
																			breadCrumbList={breadCrumb}
																		/>
																	</section>
																	{moduleName && iconName ? (
																		<section className="title-wrapper">
																			<PageHeader
																				moduleName={moduleName}
																				iconName={iconName}
																			/>
																		</section>
																	) : null}
																</wrapper>
															</section>
															{component}
														</Wrapper>
													</Route>
												);
											})}
										</Switch>
									) : (
										<AccessDeniedMessage />
									)
								) : (
									<h1>{labels.serverErrorMessage}</h1>
								)}
							</section>
						</Main>
					)}
				</section>
			</React.Fragment>
		);
	}
	render() {
		let path = this.props.location?.pathname;
		return (
			<>
				{this.verifyAdminToolUrl(path)
					? this.getAdminAppContainer()
					: this.getUniversalAppContainer()}
			</>
		);
	}
}

const mapStateToProps = (storeState) => {
	return {
		userSettings: storeState.userSettings,
		isLoading: storeState.isLoading,
		userPermissions: storeState.userPermissions,
		featureConfiguration: storeState.featureConfiguration,
		displayCookieConsent: storeState.adobeAnalytics.promptForConsent
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(
			Object.assign({}, UserSettingsAction, FeatureConfigurationAction, {
				initAdobeAnalytics: adobeAnalytics.initAdobeAnalytics,
				setConsentResult: adobeAnalytics.setConsentResult,
				trackEvent: adobeAnalytics.trackEvent
			}),
			dispatch
		)
	};
};

export default hot(module)(
	connect(mapStateToProps, mapDispatchToProps)(withRouter(App))
);
